import React from 'react'
import styled from 'styled-components'
import { css } from '@emotion/core'
import BeatLoader from 'react-spinners/BeatLoader'

const override = css`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`

export const Overlay = styled.div`
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.05);

  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
`

/**
 * @param {object} props
 * @param {boolean} [props.isFetching]
 */
function LoadingBar({ isFetching = false }) {
  return (
    isFetching && (
      <Overlay>
        <BeatLoader css={ override } loading={ isFetching } size={ 24 } sizeUnit="px" color="#D44B49" />
      </Overlay>
    )
  )
}

export default LoadingBar



// WEBPACK FOOTER //
// ./src/lib/components/LoadingBar.jsx